import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ImageSlash({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass || undefined}
      width={width || undefined}
    >
      <path fill="currentColor" d="M73 39.1C63.6 29.7 48.4 29.7 39.1 39.1C29.8 48.5 29.7 63.7 39 73.1L567 601.1C576.4 610.5 591.6 610.5 600.9 601.1C610.2 591.7 610.3 576.5 600.9 567.2L538.8 505.1C542.1 497.4 543.9 488.9 543.9 480L543.9 160C543.9 124.7 515.2 96 479.9 96L160 96C151.1 96 142.6 97.8 134.9 101.1L72.9 39.1zM177.8 144L480 144C488.8 144 496 151.2 496 160L496 462.2L463.4 429.6C464.8 423.7 463.9 417.3 460.7 411.9L380.7 275.9C376.4 268.6 368.5 264.1 360 264.1C351.5 264.1 343.6 268.6 339.3 275.9L328.3 294.5L177.8 144zM96 197.8L96 480C96 515.3 124.7 544 160 544L442.2 544L394.2 496L160 496C151.2 496 144 488.8 144 480L144 245.8L96 197.8zM312 448L346.2 448L233.1 334.9L180.4 410.2C175.3 417.5 174.6 427.1 178.8 435C183 442.9 191.1 448 200 448L312 448z" />
    </svg>
  );
}
